import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { MerchantUser } from '@root/globalTypes';

export function useGetUserByToken({
  type,
  token,
}: {
  type: 'invitations' | 'password';
  token: string;
}) {
  const { query } = useApi();

  const { data, isPending } = useQuery<MerchantUser>({
    queryKey: [...queryKeys.merchantUsers, token],
    queryFn: (): Promise<MerchantUser> =>
      query({
        path: `v1/merchant/users/${type}/${token}`,
        useAuth: false,
      }),
    enabled: Boolean(token),
  });

  return {
    data: data,
    isPending,
  };
}
